import { Button, IconClear, IconDone, IconRefresh } from '@capitalise/ui-design-system';
import ProductOptionsDropdown, { options } from './ProductOptionsDropdown';
import { GapFlexBox } from 'modules/Business/containers/Funding/styled';
import PropTypes from 'prop-types';
import { FundingMatchStatus } from 'enums/funding-match-status';
import { Analytics } from 'utils/Analytics';
import { AnalyticsEventAction, AnalyticsEventCategory } from 'enums/analytics-types';

const MatchCardButtons = ({
  status,
  showButtons,
  showResubmitButton,
  isMobile,
  onButtonClick,
  name,
}) => {
  const handleResubmitClick = () => {
    if (status !== FundingMatchStatus.incomplete) {
      Analytics.track(
        AnalyticsEventCategory.profileApplication,
        AnalyticsEventAction.resubmitLenders,
        {
          lenderSelected: name,
        },
      );
    }
    onButtonClick(options.FAILED_LENDER);
  };
  return (
    <GapFlexBox display="flex" flexDirection="column">
      {showResubmitButton && (
        <Button
          baseColor="green"
          variant="filled"
          size="small"
          leftIcon={<IconRefresh />}
          onClick={handleResubmitClick}
        >
          {status === FundingMatchStatus.incomplete ? 'Submit' : 'Resubmit'}
        </Button>
      )}

      {showButtons && (
        <Button
          baseColor="green"
          variant="filled"
          size="small"
          leftIcon={<IconDone />}
          onClick={() => {
            onButtonClick(options.CONTINUE_WITH_OFFER);
          }}
        >
          Continue with offer
        </Button>
      )}
      <GapFlexBox gap="xtiny" display="flex" justifyContent="space-between">
        {isMobile && <ProductOptionsDropdown status={status} onSelect={onButtonClick} />}
        {showButtons && (
          <Button
            fullWidth
            baseColor="grey"
            size="small"
            variant="secondary"
            leftIcon={<IconClear />}
            onClick={() => {
              onButtonClick(options.DECLINE_OFFER);
            }}
          >
            Decline
          </Button>
        )}
        {!isMobile && <ProductOptionsDropdown status={status} onSelect={onButtonClick} />}
      </GapFlexBox>
    </GapFlexBox>
  );
};

MatchCardButtons.propTypes = {
  status: PropTypes.number,
  showButtons: PropTypes.bool,
  showResubmitButton: PropTypes.bool,
  isMobile: PropTypes.bool,
  onButtonClick: PropTypes.func,
  name: PropTypes.string,
};

export default MatchCardButtons;
